import { Star, StarHalf } from "lucide-react";

export function MockRatingStars({ rating }: { rating: number }) {
  const clamped = Math.min(5, Math.max(0, rating));
  const full = Math.min(5, Math.floor(clamped));
  const hasHalf = full < 5 && clamped - full >= 0.25;
  const empty = 5 - full - (hasHalf ? 1 : 0);

  return (
    <div className="inline-flex items-center justify-center gap-0.5" aria-hidden>
      {Array.from({ length: full }).map((_, i) => (
        <Star key={`f${i}`} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
      ))}
      {hasHalf ? <StarHalf className="h-3.5 w-3.5 fill-amber-400 text-amber-400" /> : null}
      {Array.from({ length: empty }).map((_, i) => (
        <Star key={`e${i}`} className="h-3.5 w-3.5 text-slate-200" />
      ))}
    </div>
  );
}

